import React, { Component } from 'react';
import styles from './Customers.module.css';
import { Link } from 'react-router-dom';

import logo from '../../images/CVE_logo_shadow.svg';
import customerImg from '../../images/customers.jpg';
import fishesImg from '../../images/fishes.png';
import mealImg from '../../images/meal.png';

import Menu from '../../containers/Menu/Menu';
import IntroSection from '../../components/IntroSection/IntroSection';
import ImgSection from '../../components/ImgSection/ImgSection';

export default class Customers extends Component {
  render() {
    return (
      <div className={styles.Customers}>
        <Menu strokeColor="#000" />
        <div className={styles.nav}>
          <div className={styles.left}>
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className={styles.right}>
            {/* <div>
              {
                [...Array(4)].map((_, index) => {
                  if (index === (indicator - 1)) {
                    return <div key={index} style={{ width: '15px', transition: 'width 0.1s ease-out' }} />
                  } else {
                    return <div key={index} />
                  }
                })
              }
            </div> */}
          </div>
        </div>
        <IntroSection heading="Our wholesome products" textImg={customerImg} fontSize="80px" description="We Harvest the Finest Catfish for Home Consumption and Commercial Sales" />
        <ImgSection heading="Clean &amp; fresh" image={fishesImg} />
        <ImgSection heading="Local &amp; sustainable" content={(
          <div>
            <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</p>
            <p>At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam</p>
            <div>
              <div>BADGE</div>
              <div>BADGE</div>
            </div>
          </div>
        )} right />
        <ImgSection heading="Nutritious &amp; convenient" image={mealImg} />
      </div>
    )
  }
}
